import $ from 'jquery';

$(function () {
    const r_form = $('.rs_search-form');
    const a_form = $('.as_search-form');

    r_form.on('submit', function (e) {
        e.preventDefault();

        const params = r_form.serializeArray();

        const type = 'research tools';
        const s = params.find((el) => el.name == 's').value;

        let searchLocation = type;
        window.location = window.location.origin + `?searchLocation=${type}&${new URLSearchParams({ s }).toString()}`;
    });

    a_form.on('submit', function (e) {
        e.preventDefault();

        const params = a_form.serializeArray();

        const a = params.find((el) => el.name == 'a').value;

        const articlesParams = new URLSearchParams({
            authtype: 'ip,guest',
            direct: 'true',
            site: 'eds-live',
            scope: 'site',
            type: '0',
            custid: 'columbus',
            groupid: 'main',
            profid: 'eds',
            mode: 'bool',
            lang: 'en',
            cli0: 'FT',
            clv0: 'Y',
            cli1: 'DISCIPLINE',
            clv1: '',
            bquery: a,
        });

        window.location = `https://search.ebscohost.com/login.aspx?${articlesParams.toString()}`;
    });
});
